import { SectionContent } from '../../amrPipeline/common/section/SectionContent';
import IconSVG from '../../../styles/svg-icons';
import { useField } from 'formik';
import { roles } from '../../../constants';
import { user } from '../../../user';
import { TextareaField } from '../../common/form-fields/TextareaField';
import { TextField } from '../../common/form-fields/TextField';
import { AppState } from '../../../types/state/AppState';
import { useSelector } from 'react-redux';

export const CompanyProfile = () => {
    const selectedManager = useSelector((state: AppState) => state.cloManagers.selectedManager);
    const [descriptionField, , descriptionHelpers] = useField('description');
    const [generatedDescriptionField] = useField('generatedDescription');

    const resetDescriptionDisabled = generatedDescriptionField.value === descriptionField.value;

    const isAdminOrDataEntry = user.hasRoles(roles.Administrator, roles.DataEntry);

    const handleResetDescription = () => {
        descriptionHelpers.setValue(generatedDescriptionField.value);
    };

    return (
        <SectionContent title="Company Profile" className="data-item-company-profile" actionBtn={
            selectedManager?.details?.stats.totalDeals ? (
                <button className="btn-link" onClick={handleResetDescription} disabled={resetDescriptionDisabled}>
                    <IconSVG name="undo" width={16} height={16} />
                    Reset to auto-generated description
                </button>
            ) : null
        }>
            <TextareaField
                label="Company Description"
                name="description"
                wrapperClassName="data-item-row-full-height"
                maxLength={2048}
            />
            {isAdminOrDataEntry && (
                <div className="data-item data-item-general-cols">
                    <div className="data-item-content">
                        <div className="content-row">
                            <div className="content-col">
                                <TextField label="Platform Overview" name="platformOverview" />
                            </div>
                            <div className="content-col">
                                <TextField label="Webinar Video Link" name="webinarVideo" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </SectionContent>
    );
};
